import axios from 'axios'

export default {
    create() {
        return axios.post('/against-computer')
    },

    answer(params) {
        return axios.post('/against-computer/answer', {
            answer_id: params.answer,
            question_id: params.question.id,
            quiz_id: params.quiz.id,
            left_time: params.leftTime
        })
    },

    getQuestion(quiz) {
        return axios.get('/against-computer/question', {
            params: {
                quiz_id: quiz.id
            }
        })
    }
}
